import { CAMPAIGN_VARIABLES, couponValueLabel, renderMessage } from '@crm/shared';

const EXEMPLO = Object.fromEntries(CAMPAIGN_VARIABLES.map((item) => [item.key, item.sample]));

/**
 * O texto no formato em que ele vai sair. E o mesmo balao da tela de conversas:
 * ler a frase pronta evita a mensagem que so parece boa dentro do campo.
 */
export function WhatsappBubble({
  body,
  coupon,
}: {
  body: string;
  /** Quando a campanha ja escolheu o cupom, a previa usa o dele - nao o de exemplo. */
  coupon?: { code: string; type: string; value: number } | null;
}) {
  const valores = {
    ...EXEMPLO,
    ...(coupon ? { cupom: coupon.code, cupom_valor: couponValueLabel(coupon) } : {}),
  };

  return (
    <div className="rounded-card bg-muted/40 p-3">
      <div className="flex justify-end">
        <div className="relative max-w-[80%] rounded-2xl rounded-br-sm bg-primary px-3 py-2 text-primary-foreground shadow-sm after:absolute after:bottom-0 after:right-[-5px] after:h-3 after:w-3 after:rotate-45 after:bg-primary after:content-['']">
          <p className="whitespace-pre-wrap break-words text-sm">{renderMessage(body, valores)}</p>
        </div>
      </div>
    </div>
  );
}
